<main [class.is-chart-card]="isChartCard">
  <div class="no-data-container">
    <img src="../../../../assets/images/gen4u/no-data-file.svg" />
    <span
      >{{ firstParagraph }}<br />
      {{ secondParagraph }}</span
    >
  </div>
</main>
